module.exports = "/fonts/vendor/devextreme/dist/css/icons/dxicons.woff2?5bb1efb089612be501ba79ff46e3e95a";